import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">

            <div className="footer-container">
                <div className="footer-logo">
                    {/* <img src="" alt="psyche" /> */}
                </div>
                <div className="footer-links">
                    <div className="footer-column">
                        <h4>For Businesses</h4>
                        <a href="#!">Online Crypto Payments</a>
                        <a href="#!">Email Billing</a>
                        <a href="#!">Crypto Payouts</a>
                        <a href="#!">In-store Payments</a>
                        <a href="#!">Crypto Donations</a>
                        <a href="#!">NFTs</a>
                        <a href="#!">Exchange Rates</a>
                        <a href="#!">Business FAQs</a>
                        <a href="#!">Pricing</a>
                        <a href="#!">Resources</a>
                    </div>
                    <div className="footer-column">
                        <h4>For Individuals</h4>
                        <a href="#!">HODL Pay</a>
                        <a href="#!">Crypto Wallet</a>
                        <a href="#!">Browser Extension</a>
                        <a href="#!">Spend Crypto</a>
                        <a href="#!">Merchant Directory</a>
                        <a href="#!">Buy Gift Cards</a>
                        <a href="#!">Buy Crypto</a>
                        <a href="#!">Blog</a>
                        <a href="#!">Support</a>
                    </div>
                    <div className="footer-column">
                        <h4>Developers</h4>
                        <a href="#!">Integrations</a>
                        <a href="#!">Bitcore</a>
                        <a href="#!">Insight</a>
                        <a href="#!">Open Source</a>
                        <a href="#!">PGP Keys</a>
                        <a href="#!">Status</a>
                    </div>
                    <div className="footer-column">
                        <h4>Company</h4>
                        <a href="#!">About</a>
                        <a href="#!">Careers</a>
                        <a href="#!">Press</a>
                        <a href="#!">Brand Guide</a>
                        <a href="#!">Stats</a>
                        <a href="#!">Legal</a>
                        <a href="#!">Privacy</a>
                        <a href="#!">Complaints</a>
                        <a href="#!">Your Privacy Choices</a>
                        <a href="#!">Accessibility Statement</a>
                    </div>
                </div>
                <div className="footer-subscribe">
                    <input type="email" placeholder="Enter email" />
                    <button>Subscribe</button>
                    <p>By submitting this form, you agree to receive marketing and other communications from Psyche about Psyche products and other company updates. You can unsubscribe from these communications at any time. For more information on our privacy practices, please review our <a href="#!">Privacy Policy</a>.</p>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-social">
                    <a href="#!">in</a>
                    <a href="#!">t</a>
                </div>
                <p>Copyright © 2025 Psyche Gate. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;